var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "branch-subset-selection"
  }, [_c('b-button', {
    staticClass: "branch-subset-selection__open-modal-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": _vm.handleOpenModalButtonIsClicked
    }
  }, [_vm._v(" 選擇分店 ")]), _c('div', {
    staticClass: "branch-subset-selection__preview-selection ml-3"
  }, [_vm.isFetchingPreselectedBranchModels ? _c('b-spinner', {
    staticStyle: {
      "border-width": "1px"
    },
    attrs: {
      "small": ""
    }
  }) : [_vm._l(_vm.sortedSelectedBranchModels, function (selectedShopModel, i) {
    return _c('span', {
      key: i,
      staticClass: "branch-subset-selection__selected-branch-name",
      class: {
        'd-none': i >= _vm.previewBranchNameCount
      }
    }, [_vm._v(" " + _vm._s(_vm.displayNameForBranchModel(selectedShopModel)) + " ")]);
  }), _vm.selectedShopModels.length > _vm.previewBranchNameCount ? _c('span', {
    staticClass: "branch-subset-selection__selected-branch-name"
  }, [_vm._v("+" + _vm._s(_vm.selectedShopModels.length - _vm.previewBranchNameCount))]) : _vm._e()]], 2), _c('b-modal', {
    ref: "modal",
    attrs: {
      "title": "選擇分店來源",
      "ok-title": "確認",
      "cancel-title": "取消",
      "size": "lg",
      "dialog-class": "branch-subset-selection__modal"
    },
    on: {
      "shown": _vm.handleAreaSelectionModalIsShown,
      "ok": _vm.handleOkIsClicked,
      "cancel": _vm.handleCancelIsClicked
    }
  }, [_c('div', {
    staticClass: "branch-subset-selection__candidate-section"
  }, [_c('b-tabs', {
    staticClass: "branch-subset-selection__tabs",
    attrs: {
      "content-class": "branch-subset-selection__tab-content"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "自行選取",
      "active": ""
    }
  }, [_c('div', {
    staticClass: "branch-subset-selection__header-section"
  }, [_c('AppSingleSelect', {
    attrs: {
      "options": _vm.branchOptions,
      "placeholder": "查詢分店"
    },
    on: {
      "input": _vm.handleSearchedCandidateBranchChanged
    },
    model: {
      value: _vm.searchedCandidateBranchId,
      callback: function callback($$v) {
        _vm.searchedCandidateBranchId = $$v;
      },
      expression: "searchedCandidateBranchId"
    }
  }), _c('hr', {
    staticClass: "my-3"
  }), _c('AreaSelection', {
    ref: "area-selection-for-branch-subset",
    attrs: {
      "branch-provider": "waltily.branch",
      "show-branch-code": _vm.vModelForShowBranchCode,
      "placeholder": "請選擇區域",
      "api-source": "admin"
    },
    on: {
      "selected": _vm.handleAreaIsSelected,
      "childrenAreUpdated": _vm.handleChildrenBranchesAreUpdated
    }
  }), _vm.candidateShopModels.length > 0 ? _c('p', {
    staticClass: "mt-4 mb-2",
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v(" 請選擇分店： ")]) : _vm._e()], 1), _c('div', {
    staticClass: "branch-subset-selection__scrollable-body"
  }, [_vm.isFetchingCandidates ? [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center",
    staticStyle: {
      "height": "64px"
    }
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1)] : [_vm.candidateShopModels.length > 1 ? _c('div', {
    staticClass: "branch-subset-selection__candidate-branch",
    on: {
      "click": _vm.handleSelectAllShopIsClicked
    }
  }, [_c('button', {
    staticClass: "branch-subset-selection__select-button",
    class: {
      'branch-subset-selection__select-button--selected': _vm.allCandidatesAreSelected
    }
  }, [_c('i', {
    staticClass: "mdi mdi-24px mdi-check"
  })]), _c('span', {
    staticClass: "mx-4"
  }, [_vm._v("全選")])]) : _vm._e(), _vm._l(_vm.candidateShopModels, function (candidateShopModel, i) {
    return _c('div', {
      key: i,
      staticClass: "branch-subset-selection__candidate-branch",
      on: {
        "click": function click($event) {
          return _vm.handleSelectShopIsClicked(candidateShopModel);
        }
      }
    }, [_c('button', {
      staticClass: "branch-subset-selection__select-button",
      class: {
        'branch-subset-selection__select-button--selected': _vm.selectedShopIds.includes(candidateShopModel.id)
      }
    }, [_c('i', {
      staticClass: "mdi mdi-24px mdi-check"
    })]), _c('span', {
      staticClass: "mx-4"
    }, [_vm._v(_vm._s(_vm.displayNameForBranchModel(candidateShopModel)))])]);
  })]], 2)]), _c('b-tab', {
    attrs: {
      "title": "整批匯入"
    }
  }, [_c('div', {
    staticClass: "branch-subset-selection__batch-import"
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "6",
      "placeholder": "整批貼入分店代號，一行一個分店代號，可貼入多行"
    },
    model: {
      value: _vm.batchBranchCodesText,
      callback: function callback($$v) {
        _vm.batchBranchCodesText = $$v;
      },
      expression: "batchBranchCodesText"
    }
  }), _c('div', {
    staticClass: "text-right mt-2"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.isImportingBranches
    },
    on: {
      "click": _vm.handleBatchImportIsClicked
    }
  }, [_vm.isImportingBranches ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" 匯入 ")], 1)], 1), _c('p', {
    staticClass: "mt-3 mb-2",
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v(" 匯入數量，共 " + _vm._s(_vm.importedBranchCount) + " 筆"), _c('br'), _vm._v(" " + _vm._s(_vm.importedMatchedBranchCount) + " 筆比對成功。 ")]), _c('hr', {
    staticClass: "my-3"
  }), _c('p', {
    staticClass: "mb-2",
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v("查無分店，共 " + _vm._s(_vm.unmatchedBranchCodes.length) + " 筆，明細如下：")]), _c('b-form-textarea', {
    staticClass: "branch-subset-selection__unmatched-textarea",
    attrs: {
      "value": _vm.unmatchedBranchCodes.join('\n'),
      "rows": "8",
      "readonly": ""
    }
  })], 1)])], 1)], 1), _c('div', {
    staticClass: "branch-subset-selection__selected-section"
  }, [_c('div', {
    staticClass: "branch-subset-selection__header-section"
  }, [_c('div', {
    staticClass: "branch-subset-selection__selected-top-row"
  }, [_c('p', {
    staticClass: "mb-2",
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v("已選分店，共 " + _vm._s(_vm.selectedShopModels.length) + " 間")]), _c('label', {
    staticClass: "d-inline-flex align-items-center mb-2"
  }, [_c('span', {
    staticClass: "mr-2",
    staticStyle: {
      "color": "#777"
    }
  }, [_vm._v("是否顯示分店代號")]), _c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    on: {
      "input": function input(value) {
        return _vm.$emit('update:showBranchCode', value);
      }
    },
    model: {
      value: _vm.vModelForShowBranchCode,
      callback: function callback($$v) {
        _vm.vModelForShowBranchCode = $$v;
      },
      expression: "vModelForShowBranchCode"
    }
  })], 1)]), _vm.selectedShopModels.length > 0 && false === _vm.isFetchingPreselectedBranchModels ? _c('b-input', {
    staticClass: "form-control my-2",
    attrs: {
      "type": "text",
      "maxlength": "20",
      "placeholder": "查詢已選分店"
    },
    model: {
      value: _vm.selectedShopKeyword,
      callback: function callback($$v) {
        _vm.selectedShopKeyword = $$v;
      },
      expression: "selectedShopKeyword"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "branch-subset-selection__scrollable-body"
  }, [_vm.isFetchingPreselectedBranchModels ? [_c('div', {
    staticClass: "d-flex justify-content-center align-items-center",
    staticStyle: {
      "height": "64px"
    }
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1)] : _vm._l(_vm.filteredSelectedBranchModels, function (selectedShopModel, i) {
    return _c('div', {
      key: i,
      staticClass: "branch-subset-selection__selected-branch"
    }, [_c('span', {
      staticClass: "mr-4"
    }, [_vm._v(_vm._s(_vm.displayNameForBranchModel(selectedShopModel)))]), _c('button', {
      staticClass: "branch-subset-selection__clean-button ml-auto",
      on: {
        "click": function click($event) {
          return _vm.handleCleanSelectedShopIsClicked(selectedShopModel);
        }
      }
    }, [_c('i', {
      staticClass: "mdi mdi-24px mdi-close"
    })])]);
  })], 2)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }